"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataViewFiltersWatcher = dataViewFiltersWatcher;

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(dataViewFiltersWatcher);

// import { all, put, takeEvery, select, call } from 'redux-saga/effects';
// import * as types from "./types";
// import * as core.actions from "./core.actions";
// import * as apiDataViewActions from "core.store/apiFlow/data/core.actions";
// import { getProperty } from "core.store/data/app.views/selectors";
//
//
// function* dataViewFiltersApply(action) {
//     const { dataType, values } = action.payload;
//
//     yield put(core.actions.apply(dataType, values));
//
//     const state = yield select();
//     //
//     // if(getProperty(state, dataType, DATA_VIEW_PROPS.IS_MOUNTED)){
//     //     yield put(apiDataViewActions.load(dataType));
//     // }
// }
//
//
// function* dataViewFiltersReset(action) {
//     const { dataType } = action.payload;
//
//     yield put(core.actions.reset(dataType));
//
//     const state = yield select();
//
//     // if(getProperty(state, dataType, DATA_VIEW_PROPS.IS_MOUNTED)){
//     //     yield put(apiDataViewActions.load(dataType));
//     // }
// }
function dataViewFiltersWatcher() {
  return regeneratorRuntime.wrap(function dataViewFiltersWatcher$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}